module.exports = __webpack_public_path__ + "img/image02_sp.1652c751.jpg";